import { render, staticRenderFns } from "./FormInfoCategory.vue?vue&type=template&id=f9770d4c&"
import script from "./FormInfoCategory.vue?vue&type=script&lang=js&"
export * from "./FormInfoCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9770d4c')) {
      api.createRecord('f9770d4c', component.options)
    } else {
      api.reload('f9770d4c', component.options)
    }
    module.hot.accept("./FormInfoCategory.vue?vue&type=template&id=f9770d4c&", function () {
      api.rerender('f9770d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/infoCategories/form/FormInfoCategory.vue"
export default component.exports